import { InMemoryCache } from "@apollo/client";

import { possibleTypes } from "@shared/data/client/possibleTypes";

const getCache = () =>
  new InMemoryCache({
    possibleTypes,
    typePolicies: {
      Query: {
        fields: {
          viewer: {
            merge: true,
          },
        },
      },
      Mutation: {
        fields: {
          viewer: {
            merge: true,
          },
        },
      },
      Viewer: {
        // This means the singleton Viewer's identity does not depend on any of its
        // fields (except for __typename), making the ID effectively constant.
        keyFields: [],
      },
    },
  });

export { getCache };
